import { IQueryParams } from '../../../../models';
import { clearServiceList, getServiceListFail, getServiceListStarted, getServiceListSuccess } from '../../../reducer/services/ServiceListReducer';
import { getAllServices } from '../../actionType/services/ServiceActionTypes';

import {
  IClearAllServiceList,
  IGetAllServiceFailure,
  IGetAllServiceFailurePayload,
  IGetAllServiceRequest,
  IGetAllServiceStarted,
  IGetAllServiceSuccess,
  IGetAllServiceSuccessPayload
} from '../../types/services/GetAllServiceTypes';

export const getAllServiceRequest = (pageNo: number, item: number, queryParams?: IQueryParams, sort?: string): IGetAllServiceRequest => ({
  type: getAllServices.FETCH_ALL_SERVICE_REQUEST,
  pageNo,
  item,
  queryParams,
  sort
});

/**
 * Fetch service started saga action
 * @returns service started action
 */
export const getAllServiceStarted = (): IGetAllServiceStarted => ({
  type: getServiceListStarted.type
});

/**
 * Fetch service success saga action
 * @param payload :Service data
 * @returns success action
 */
export const getAllServiceSuccess = (
  payload: IGetAllServiceSuccessPayload
): IGetAllServiceSuccess => ({
  type: getServiceListSuccess.type,
  payload
});

/**
 * Fetch Service Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getAllServiceFailure = (
  payload: IGetAllServiceFailurePayload
): IGetAllServiceFailure => ({
  type: getServiceListFail.type,
  payload
});

/**
 * Clear Service saga action
 */
export const clearAllServiceList = (): IClearAllServiceList => ({
  type: clearServiceList.type
});
